module.exports = __webpack_public_path__ + "static/img/tab1.1f007dc1.png";